import { Badge, BadgeProps } from '@mui/material';
import { useUnreadMessageCount } from '../../queries';

const UnreadMessagesBadge = ({ children, ...rest }: BadgeProps) => {
  const { data: unreadMessagesCount } = useUnreadMessageCount();
  const showBadge = Boolean(unreadMessagesCount);

  return (
    <Badge color='error' overlap='circular' variant={showBadge ? 'dot' : undefined} {...rest}>
      {children}
    </Badge>
  );
};

export default UnreadMessagesBadge;
